import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    height: "75vh",
    overflowX: "hidden",
    color: "var(--color-text-primary)",
  },
  formCard: {
    padding: theme.spacing(0.5, 2, 0),
    borderRadius: 16,
    border: "none",
    backgroundColor: "var(--color-background-paper)",
    boxShadow: "none",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
    width: "100%",
  },
  stepperWrap: {
    padding: 0,
    overflowX: "hidden",
    "& .MuiStepper-root": {
      padding: theme.spacing(1.5, 0),
      backgroundColor: "transparent",
    },
    "& .MuiStepIcon-root": {
      color: "var(--total_row_boldbackground)",
      fontSize: 28,
      transition: "all 0.3s ease",
    },
    "& .MuiStepIcon-root.MuiStepIcon-active": {
      color: "var(--color-primary-main)",
      filter: "drop-shadow(0 2px 4px rgba(51, 122, 183, 0.35))",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "var(--color-primary-main)",
    },
    "& .MuiStepLabel-label": {
      fontSize: 12,
      fontWeight: 500,
      color: "var(--color-text-secondary)",
      marginTop: 6,
      transition: "color 0.2s ease",
    },
    "& .MuiStepLabel-label.MuiStepLabel-active, & .MuiStepLabel-label.MuiStepLabel-completed":
      {
        color: "var(--color-text-primary) !important",
        fontWeight: "600 !important",
        opacity: "1 !important",
      },
    "& .MuiStepLabel-label.MuiStepLabel-disabled": {
      color: "var(--color-text-secondary)",
    },
    "& .MuiStepConnector-line": {
      borderColor: "var(--total_row_boldbackground)",
      borderTopWidth: 2,
    },
    "& .MuiStepConnector-active .MuiStepConnector-line": {
      borderColor: "var(--color-primary-main)",
    },
    "& .MuiStepConnector-completed .MuiStepConnector-line": {
      borderColor: "var(--color-primary-main)",
    },
  },
  stepLabel: {
    color: "var(--color-text-secondary)",
    "&$stepLabelActive": {
      color: "var(--color-text-primary) !important",
      fontWeight: "600 !important",
      opacity: "1 !important",
    },
    "&$stepLabelCompleted": {
      color: "var(--color-text-primary) !important",
      fontWeight: "600 !important",
      opacity: "1 !important",
    },
  },
  stepLabelActive: {},
  stepLabelCompleted: {},
  stepTitle: {
    marginBottom: theme.spacing(1.5),
    fontSize: 16,
    fontWeight: 700,
    color: "var(--color-text-primary)",
  },
  draftBanner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    border: "1px solid var(--total_row_boldbackground)",
    backgroundColor: "var(--total_row_background)",
    transition: "all 0.2s ease",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: theme.spacing(1.25),
      padding: theme.spacing(1.5),
    },
  },
  draftBannerContent: {
    minWidth: 0,
    flex: 1,
  },
  draftBannerTitle: {
    fontSize: 13,
    fontWeight: 700,
    marginBottom: theme.spacing(0.25),
    color: "var(--color-text-primary)",
  },
  draftBannerText: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
  },
  draftBannerActions: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "stretch",
      "& > *": {
        flex: 1,
      },
    },
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1.5, 0),
    backgroundColor: "var(--color-background-paper)",
    borderTop: "1px solid var(--total_row_boldbackground)",
    marginTop: "auto",
    flexShrink: 0,
    minHeight: 52,
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
      padding: theme.spacing(1.25, 0),
    },
  },
  actionButton: {
    minWidth: "140px",
    [theme.breakpoints.down("xs")]: {
      minWidth: 0,
      flex: 1,
    },
  },
  actionGroup: {
    display: "flex",
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      flex: "1 1 100%",
      flexWrap: "wrap",
      "& > *": {
        flex: "1 1 auto",
      },
    },
  },
  fieldsContainer: {
    overflowY: "auto",
    overflowX: "hidden",
    minHeight: 0,
    flex: 1,
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(0.5),
    "&::-webkit-scrollbar": {
      width: 5,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--total_row_boldbackground)",
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "var(--color-text-secondary)",
    },
  },
  successContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    padding: theme.spacing(4),
    textAlign: "center",
  },
  successIcon: {
    fontSize: 80,
    color: "var(--color-primary-main)",
    marginBottom: theme.spacing(2),
  },
  successTitle: {
    fontSize: "1.5rem",
    fontWeight: 600,
    color: "var(--color-text-primary)",
    marginBottom: theme.spacing(1),
  },
  successMessage: {
    fontSize: "1rem",
    color: "var(--color-text-secondary)",
    marginBottom: theme.spacing(3),
  },
  recordInfo: {
    padding: theme.spacing(2),
    backgroundColor: "var(--total_row_background)",
    borderRadius: 12,
    marginBottom: theme.spacing(3),
    minWidth: 300,
    border: "1px solid var(--total_row_boldbackground)",
  },
}));

export default useStyles;
